import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../../common/Footer";
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";
import requestUtil from "../../../helpers/requestUtil";
import useConfiguration from "../../../hooks/useConfiguration";
import useSessionStorage from "../../../hooks/useSessionStorage";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { MdOutlineLocalHospital } from "react-icons/md";
import Modal from "../../common/Modal/modal";
import Spinner from "../../common/Spinner/spinner";
import { resetJobOpportunityInfo } from "../action";
import { useDispatch } from "react-redux";
import * as Toasts from "../../common/Toastify";

const initialTemplateModalState = {status:false,template:null}
const TemplateList = () => {
  const dispatch = useDispatch();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [templateName, setTemplateName] = useState("");
  const [showDeleteTemplateModal,setShowDeleteTemplateModal] = useState(initialTemplateModalState);
  const [showError,setShowError] = useState(false);
  // ApiHandler
  const getTemplateList = async (baseURL) => {
    try {
      setIsLoading(true);
      const response = await requestUtil( `${baseURL}/Employers/get-employer-job-templates`,"POST", { employerUniqueId: login?.employerUniqueId });
      const templateList = response?.templateList?.length > 0 ? response?.templateList?.map((template) => ({
              ...template,
              isEditable: false,
            })) : [];
      setTemplateList(templateList);
      if(templateList?.length === 0){
        setShowError(true)
      }
    } catch (error) {
      setShowError(true)
      return error;
    } finally {
      setIsLoading(false);
    }
  };
  const updateTemplateNameApi = async({baseURL,payload}) => {
    try {
      setIsLoading(true);
      const response = await requestUtil(`${baseURL}/Employers/update-employer-job-templates/jobTemplateid`,'POST',payload);
      if(response?.result){
        Toasts.success(response?.message);
        return true
      }
      Toasts.error(response?.message);
      return false;
    } catch (error) {
      Toasts.error(error?.message);
      return false
    } finally {
      setIsLoading(false);
    }
  }
  const deleteTemplateApi = async({baseURL,templateId}) => {
    try {
      setIsLoading(true);
      const response = await requestUtil(`${baseURL}/Employers/delete-employer-job-templates/jobTemplateid`,'POST',{"jobtemplateId": templateId});
      if(response?.result){
        Toasts.success(response?.message);
        return true
      }
      Toasts.error(response?.message);
      return false;
    } catch (error) {
      Toasts.error(error?.message);
      return false
    } finally {
      setIsLoading(false);
    }
  }
  // Event Handler
  const editTemplateHandler = (item) => {
    const copyTemplateList = [...templateList];
    const updatedList = copyTemplateList?.map((template) => {
      if (template?.id === item?.id) {
        return { ...template, isEditable: true };
      }
      return { ...template, isEditable: false };
    });
    setTemplateList(updatedList);
    setTemplateName(item?.name);
  };
  const templateNameChangeHandler = (e) => {
    const { value } = e.target;
    setTemplateName(value);
  };
  const updateHandler = async(item) => {
      // validation 
    if(!templateName ||templateName?.length === 0) {
      return;
    };
    const payload =  {
      "jobTemplateId": item?.id,
      "jobTemplateName": templateName,
    }
    const isUpdatedTemplateName = await updateTemplateNameApi({baseURL:config.baseUrl,payload});
    if(!isUpdatedTemplateName) return;
    const copyTemplateList = [...templateList];
    const updatedTemplateList = copyTemplateList?.map((template) => {
      if (template?.id === item?.id) {
        return { ...template, name: templateName, isEditable: false };
      }
      return template;
    });
    setTemplateList(updatedTemplateList);
  };
  const cancelHandler = (item) => {
    const copyTemplateList = [...templateList];
    const updatedTemplateList = copyTemplateList?.map((template) => {
      return { ...template, isEditable: false };
    });
    setTemplateList(updatedTemplateList);
  };
  const showDeleteTemplateModalHandler = item => {
    setShowDeleteTemplateModal(prev => ({...prev,status:true,template:item}));
  }
  const deleteTemplateHandler = async() => {
    const isDeletedTemplate = await deleteTemplateApi({baseURL:config.baseUrl,templateId:showDeleteTemplateModal?.template?.id});
    setShowDeleteTemplateModal(initialTemplateModalState)
    if(!isDeletedTemplate) return;
    const copyTemplateList = [...templateList];
    const updatedTemplateList = copyTemplateList?.filter(
      (template) => template?.id !== showDeleteTemplateModal?.template?.id
    );
    setTemplateList(updatedTemplateList);
    setShowDeleteTemplateModal(initialTemplateModalState)
  };
  const closeDeleteTemplateMoalHandler = () => {
    setShowDeleteTemplateModal(initialTemplateModalState)
  }
  const navigateToStartWithTemplate = (item) => {
    navigate("/jobopportunity", {
      state: {
        postion: {
          newPost: false,
          fromTemplate: true,
          createTemplate: false,
          editJobPost: false,
        },
        templateId: item?.id,
      },
    });
  };
  const navigateToTemplatePage = () => {
    dispatch(resetJobOpportunityInfo())
    navigate("/jobopportunity", {
      state: {
        postion: {
          newPost: false,
          fromTemplate: false,
          createTemplate: true,
          editJobPost: false,
        },
      },
    });
  }
  // sideEffecrs
  useEffect(() => {
    if (config.baseUrl) {
      getTemplateList(config.baseUrl);
    }
  }, [config.baseUrl]);
  return (
    <div className="page main-margin">
      {/* <Loader /> */}
      {isLoading && <Spinner />}
      <Header />
      <Sidebar />
      <div className="page-main">
        <div className="main-content app-content mt-0 main-background">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                <h1 className="page-title">Template List</h1>
              </div>
              {showDeleteTemplateModal?.status ? (
                <Modal
                  showHide={closeDeleteTemplateMoalHandler}
                  saveFunction={deleteTemplateHandler}
                  label={"Alert"}
                  size={"md"}
                  center={true}
                  onlyClose={false}
                  buttonName={"Delete"}
                >
                  <span className="fw-bold">
                    Are you sure want to delete this template ?
                  </span>
                </Modal>
              ) : null}
              <div className="row">
                <div className="col-xl-12 col-md-12 col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <table className="table">
                        <thead>
                          <tr style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4,minmax(0,1fr))",
                              }}>
                            <th className="w-100">No</th>
                            <th className="w-100">Template Name</th>
                            <th className="w-100">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(templateList?.length > 0) ? (
                            templateList?.map((template, index) => (
                              <tr style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4,minmax(0,1fr))",
                              }}>
                                <td className="w-100">{index + 1}</td>
                                {template?.isEditable ? (
                                  <td className="w-100">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name="templateName"
                                      id="templateName"
                                      value={templateName}
                                      onChange={templateNameChangeHandler}
                                    />
                                    {!templateName ? (
                                      <div className="invalid-input">
                                        This field is required
                                      </div>
                                    ) : null}
                                  </td>
                                ) : (
                                  <td className="w-100">{template?.name}</td>
                                )}
                                <td className="w-100">
                                  <div
                                    style={{ columnGap: "0.75rem"}}
                                    className="d-flex align-items-center "
                                  >
                                    {template?.isEditable ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          columnGap: "1rem",
                                        }}
                                      >
                                        <button
                                          onClick={() =>
                                            updateHandler(template)
                                          }
                                          className="btn btn-primary"
                                        >
                                          Update
                                        </button>
                                        <button
                                          onClick={() =>
                                            cancelHandler(template)
                                          }
                                          className="btn btn-outline-primary"
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    ) : (
                                      <button
                                        id="bAcep"
                                        type="button"
                                        class="btn  btn-sm btn-height"
                                        title="Edit Template Name"
                                        style={{ fontSize: "1.1rem" }}
                                        onClick={() =>
                                          editTemplateHandler(template)
                                        }
                                      >
                                        <FiEdit />
                                      </button>
                                    )}
                                    <button
                                      id="bAcep"
                                      type="button"
                                      class="btn  btn-sm btn-height"
                                      title="Delete Template"
                                      style={{ fontSize: "1.1rem" }}
                                      onClick={() =>
                                        showDeleteTemplateModalHandler(template)
                                      }
                                    >
                                      <FiTrash2 />
                                    </button>
                                    <button
                                      id="bAcep"
                                      type="button"
                                      class="btn  btn-sm btn-height"
                                      title="Create shift with this template"
                                      style={{ fontSize: "1.1rem" }}
                                      onClick={() =>
                                        navigateToStartWithTemplate(template)
                                      }
                                    >
                                      <MdOutlineLocalHospital />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )  : showError ? (
                            <div className="d-flex align-items-center justify-content-center flex-column py-2">
                              <div class="errorMessage">No Records Found</div>
                              <button
                                onClick={navigateToTemplatePage}
                                className="btn btn-primary"
                              >
                                Create a template
                              </button>
                            </div>
                          ) : null}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TemplateList;
